import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBoxObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationPostureHeelPosition extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Posture - Heel Position' />
                    <label className={styles.label}>Heel Position</label>
                    <span className={styles.sublabel} />
                    <label className={styles.col_1_header}>R</label>
                    <label className={styles.col_1_header}>L</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <label className={styles.sublabel} >Inverted</label>
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEELPOSINVR'
                        className={styles.lr_checkbox}
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEELPOSINVL'
                        className={styles.lr_checkbox}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <label className={styles.sublabel} >Everted</label>
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEELPOSEVR'
                        className={styles.lr_checkbox}
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEELPOSEVL'
                        className={styles.lr_checkbox}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <label className={styles.sublabel} >WB Anterior</label>
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEELPOSWBANTR'
                        className={styles.lr_checkbox}
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEELPOSWBANTL'
                        className={styles.lr_checkbox}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <label className={styles.sublabel} >WB Posterior</label>
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEELPOSWBPOSR'
                        className={styles.lr_checkbox}
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEELPOSWBPOSL'
                        className={styles.lr_checkbox}
                    />
                </div>
            </div >
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEELPOSINVR ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEELPOSINVL ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEELPOSEVR ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEELPOSEVL ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEELPOSWBANTR ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEELPOSWBANTL ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEELPOSWBPOSR ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEELPOSWBPOSL
            ? true : false
    };
}

const connectedObservationPostureHeelPosition = connect(mapStateToProps)(ObservationPostureHeelPosition);
export { connectedObservationPostureHeelPosition as ObservationPostureHeelPosition };


